"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DailymedConcerns = void 0;
var DailymedConcerns;
(function (DailymedConcerns) {
    DailymedConcerns["addMedicine"] = "dailymed.concernAddMedicine";
    DailymedConcerns["removeMedicine"] = "dailymed.concernRemoveMedicine";
    DailymedConcerns["changeDosage"] = "dailymed.concernChangeDosage";
    DailymedConcerns["changeDeliveryDate"] = "dailymed.concernChangeDeliveryDate";
    DailymedConcerns["stopDailymed"] = "dailymed.concernStopDailymed";
    DailymedConcerns["otherChoice"] = "dailymed.concernOtherChoice";
})(DailymedConcerns || (exports.DailymedConcerns = DailymedConcerns = {}));
//# sourceMappingURL=dailymed.js.map